import { render } from "./VulInfoTab.vue?vue&type=template&id=fea9b0c4"
import script from "./VulInfoTab.vue?vue&type=script&lang=js"
export * from "./VulInfoTab.vue?vue&type=script&lang=js"

import "./VulInfoTab.vue?vue&type=style&index=0&id=fea9b0c4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__